module.exports = " <div class=Leftcolumn> <slot></slot> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./~/eslint-loader!./src/components/columns/Leftcolumn.vue
// module id = 483
// module chunks = 1